import {PropsWithChildren, ReactElement} from "react";
import classNames from "classnames";

interface Props {
    className?: string;
}

function FrameBottomPanelFooter(props: PropsWithChildren<Props>): ReactElement {

    return (
        <div className={classNames("frame-one-bottom-panel_footer", props.className)}>
            {props.children}
        </div>
    );
}

export default FrameBottomPanelFooter;
